import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../../business/referential/UserContext';

function CopyrightVideoResponse({ Callback }) {

    const [isResponseReady, setResponseReady] = useState(false);
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const [pageId, setPageId] = useState(21);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });

        }
        process();

    }, []);

    useEffect(() => {
        if (Callback) {
            setResponseReady(true);
        }
    }, [Callback]);

    return (
        <div className="dashboard-container dashboard-container__congratulation">
            <h3 className="mb-2">
                {getContent("TitleVideoResponse")}
            </h3>
            <p className="mb-4 mb-md-5">{getContent("CRR_BROWSING")}</p>
            <p className="note">
                {getContent("SubSubTitleVideoResponse")}
            </p>
            <p className="note">
                {getContent("CRR_NOTE")}
            </p>
            <div className="bg-gray p-4 mb-5">
                {isResponseReady && <>
                    <div class="table-responsive">
                        <table className="table">
                            <thead>
                                <th scope="col">Id</th>
                                <th scope="col">IdVideo</th>
                                <th scope="col">{getContent("LtTitle")}</th>
                                <th scope="col">{getContent("LtAuthor")}</th>
                            </thead>
                            <tbody>
                                {Callback.videos.map(v =>
                                    <tr>
                                        {console.log(v)}
                                        <td>{v.videoMeta.iD_video}</td>
                                        <td>{v.videoMeta.iD_v}</td>
                                        <td>{v.videoMeta.title}</td>
                                        <td><img style={{ maxWidth: "150px", maxHeight: "150px" }} src={`data:image/jpeg;base64,${v.thumsnail}`} /></td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                </>}
            </div>
            <a href="/dashboard" className="btn btn-blue">
                {getContent("LtCount")}
            </a>
            <a href="/dashboard" className="arrow-back"></a>
        </div >
    );
}

export default CopyrightVideoResponse;